var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useRef } from "react";
import Tooltip from "./Tooltip";
import { Link } from "../Link";
import { useMergeRefs } from "../../../common/useFallbackRef";
var TooltipHover = forwardRef(function (_a, ref) {
    var id = _a.id, text = _a.text, children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "text", "children", "className", "style"]);
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var _c = useState(null), touchTimeout = _c[0], setTouchTimeout = _c[1];
    var linkRef = useRef(null);
    var combinedRef = useMergeRefs([ref, linkRef]);
    var handleShowTooltip = function () { return setIsVisible(true); };
    var handleHideTooltip = function () { return setIsVisible(false); };
    var handleTouchStart = function () {
        var timeout = window.setTimeout(function () {
            handleShowTooltip();
        }, 500);
        setTouchTimeout(timeout);
    };
    var handleTouchEnd = function () {
        if (touchTimeout) {
            window.clearTimeout(touchTimeout);
            setTouchTimeout(null);
        }
    };
    var handleKeyDown = function (event) {
        if (event.key === "Escape")
            handleHideTooltip();
    };
    var handleClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Link, __assign({}, otherProps, { ref: combinedRef, className: className, style: style, onMouseEnter: handleShowTooltip, onMouseLeave: handleHideTooltip, onFocus: handleShowTooltip, onBlur: handleHideTooltip, onKeyDown: handleKeyDown, onClick: handleClick, onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, onTouchCancel: handleTouchEnd, "aria-describedby": id, href: "#" }), children),
        React.createElement(Tooltip, { id: id, isVisible: isVisible, text: text, referentRef: linkRef })));
});
export default TooltipHover;
